import React from 'react';
import { Link } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

export const HelpIconLink = ({ path }) => {
    return (
        <Tooltip title="open help">
            <IconButton
                component={Link}
                to={path}
                // target="_blank"
                rel="noopener noreferrer"
                aria-label="help"
            >
                <HelpOutline sx={{ color: '#fafafa' }} fontSize="medium"/>
            </IconButton>
        </Tooltip>
    );
};